import { AdminLabOrderList, LabOrder } from "pwapi";

export type OrderStatus = "cancelled" | "complete" | "in_progress";
export const mapOrderStatusToLabel: { [key in OrderStatus]: string } = {
  cancelled: "Cancelled",
  complete: "Complete",
  in_progress: "",
};
export const getOrderStatus: (
  order: LabOrder | AdminLabOrderList
) => OrderStatus = ({ cancelled_at, completed_at }) => {
  if (!!completed_at && !!cancelled_at) {
    const dtCompleted = Date.parse(completed_at);
    const dtCancelled = Date.parse(cancelled_at);

    return dtCompleted > dtCancelled ? "complete" : "cancelled";
  }

  if (!!completed_at) return "complete";
  if (!!cancelled_at) return "cancelled";

  return "in_progress";
};
